import { useTheme } from "@mui/material/styles"

export default function SimpleWhiteBox(props) {
  const theme = useTheme()

  return (
    <div style={{boxShadow:'7px 7px 20px ' + theme.palette.boxShadow.main, borderRadius:'7px', margin:'5px', marginBottom:'10px', padding:'10px', backgroundColor: theme.palette.whiteBox.main, color: theme.palette.textColor.main, ...props.style}} className="simple-white-box">
      {
        props.content
      }
    </div>
  )
} 